<template>
    <div class="info-form">
        <div class="form-title">
            <p class="main-title" v-if="formTitle" v-html="formTitle"></p>
            <p class="subtitle" v-if="subTitle" v-html="subTitle"></p>
        </div>
        <v-form
            ref="form"
            class="info-form"
            :onSubmit="registerSubmit"
            :onSuccess="registerSubmitSuccess"
            :onError="registerSumbitError"
        >
            <div class="input-content">
                <div class="basic-info">
                    <input-item
                        v-for="item in basicInputs"
                        :key="item.name"
                        :item="item"
                        :showTitle="showTitle"
                        :changeLabelPos="changeLabelPos"
                    >
                        <template #custom-title>
                            <p class="title" v-html="item.title"></p>
                        </template>
                    </input-item>
                </div>
            </div>
            <div class="submit-content">
                <div class="submit-box">
                    <input
                        type="submit"
                        :value="submitText || $t('md-form.submit')"
                        class="submit"
                        :disabled="submitDisabled || !disclaimerChecked"
                        :class="{ 'submit-disabled': submitDisabled || !disclaimerChecked }"
                        :style="submitStyle"
                    />
                </div>
            </div>
        </v-form>
        <Disclaimer
            color="#a0a3af"
            :privacyText="privacyText"
            v-model:disclaimerCustomParams="disclaimerCustomParams"
            @updateChecked="checked => (disclaimerChecked = checked)"
            :btnText="submitText || $t('md-form.submit')"
        />
    </div>
</template>
<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import message from '@/mixins/message';
import inputItem from '@/components/input-item.vue';
import vForm from '@/components/v-form.vue';
import Disclaimer from '@/components/disclaimer';
import { formatSearchCondition } from './input-tool';
import { leadTypes } from '@/common/const';
const noteKeyMap = {
    meetTime: 'meeting time'
};
export default {
    emits: ['done'],
    name: 'InfoForm',
    i18next: {
        ns: 'md-form'
    },
    components: { inputItem, vForm, Disclaimer },
    mixins: [message],
    props: {
        formTitle: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        formList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        showMap: {
            type: Boolean,
            default: false
        },
        showTitle: {
            type: Boolean,
            default: false
        },
        changeLabelPos: {
            type: Boolean,
            default: false
        },
        tag: {
            type: String,
            default: ''
        },
        submitText: {
            type: String,
            default: ''
        },
        privacyText: {
            type: String,
            default: ''
        },
        submitStyle: {
            type: Object,
            default: () => {
                return {};
            }
        },
        condition: {
            type: String,
            default: ''
        },
        searchConfigMap: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data: function() {
        return {
            submitDisabled: false,
            isDone: false,
            disclaimerChecked: false,
            disclaimerCustomParams: {}
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            'page': store => store.page
        }),
        
        role({ page }) {
            return this.registerRole || page.registerUserType || leadTypes.Buyer;
        },
        noteKeyArr() {
            const baseIptName = ['fullname', 'email', 'phone', 'question'];
            return this.formList.filter(ipt => !baseIptName.includes(ipt.name));
        },
        basicInputs() {
            return this.formList.map(ipt => {
                let { title = '', required = false } = ipt;
                return {
                    ...ipt,
                    defaultValue:
                        ipt.name === 'question' ? this.defaultMsgVal : '',
                    title: required ? title.concat('<span> *</span>') : title
                };
            });
        },
        defaultMsgVal() {
            if (this.isDone) {
                return '';
            }
            let result = this.$t('md-form.defaultMsgVal') + '\n',
                conditions = JSON.parse(this.condition);
            return (
                result +
                formatSearchCondition.call(this, {
                    obj: conditions,
                    map: this.searchConfigMap
                })
            );
        }
    },
    methods: {
        registerSubmitSuccess(data = {}, isAutoRegister) {
            if (!isAutoRegister) {
                this.submitDisabled = true;
                setTimeout(() => {
                    this.submitDisabled = false;
                }, 3000);
            }
            this.tag && (data.tag = this.tag); //tag value -->formatData-->leaveMessage
            this.formatData(data); // The function is in mixins/register.js
            let note = '';
            let noteTitle = '';
            if (this.noteKeyArr.length) {
                if (data.firstName) {
                    noteTitle = this.$t('md-form.submittedAForm', {
                        name: data.firstName
                    });
                } else {
                    noteTitle = this.$t('md-form.submittedAForm', {
                        name: data.email.replace(/@.+/, '')
                    });
                }
            }
            for (let i = 0, len = this.noteKeyArr.length; i < len; i++) {
                const noteKey = this.noteKeyArr[i];
                if (data[noteKey]) {
                    note = note
                        ? note +
                          '\n' +
                          `${noteKeyMap[noteKey] || noteKey}: ` +
                          data[noteKey]
                        : `${noteKeyMap[noteKey] || noteKey}: ` + data[noteKey];
                }
            }
            if (note) {
                note = noteTitle + '\n' + note;
            }
            data.note = note;
            if (this.user && !isAutoRegister) {
                this.leaveMessage(this.onSuccessCallback); // The function is in mixins/message.js
            } else {
                isAutoRegister
                    ? this.submitRegisterInfo(null, true)
                    : this.leadRegister();
            }
        },
        leadAutoRegister(data) {
            this.registerSubmitSuccess(data, true);
        },
        registerNext() {
            if (this.inquiry) {
                this.showQuestionnaire(
                    Object.assign({}, this.questionnaire || {}, {
                        noToast: true,
                        closeCallback: () => {
                            this.onSuccessCallback();
                        }
                    })
                );
            } else {
                this.onSuccessCallback();
            }
        },
        onSuccessCallback() {
            this.$emit('done');
            // Set a completion flag for clearing msg
            this.isDone = true;
        }
    }
};
</script>
